import { render, staticRenderFns } from "./ViewTitle.vue?vue&type=template&id=64230405&"
import script from "./ViewTitle.vue?vue&type=script&lang=js&"
export * from "./ViewTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports